// src/components/HomePage.tsx
import React from 'react';
import styled from 'styled-components';

import Hero from '../homepage/Hero';
import AboutUs from '../homepage/AboutUs';
import Approach from '../homepage/Approach';
import Destinations from '../homepage/Destinations';
import Services from '../homepage/Services';
import Reviews from '../homepage/Reviews';
import Cta from '../homepage/Cta';

const HomeContainer = styled.div`
    min-height: 100vh;
    background: #ffffff;
    color: #1a1a1a;
    overflow: hidden;
`;

interface HomePageProps {
    onNavigateToTrips: () => void;
}

const HomePage: React.FC<HomePageProps> = ({ onNavigateToTrips }) => {
    return (
        <HomeContainer>
            <Hero onNavigateToTrips={onNavigateToTrips} />
            <AboutUs />
            <Approach />
            <Destinations onNavigateToTrips={onNavigateToTrips} />
            <Services />
            <Reviews />
            <Cta onNavigateToTrips={onNavigateToTrips} />
        </HomeContainer>
    );
};

export default HomePage;